<template>
  <div class="follow-user" v-show="show">
    <i v-if="is_attention" class="icon iconfont iconicon_following active"></i>
    <i v-else class="icon iconfont iconicon_focus_on"></i>
  </div>
</template>
<script>
export default {
  props: {
    show: {
      type: Boolean,
      default: false
    },
    is_attention: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {


    }
  }
}
</script>
<style lang="scss">
.follow-user {
  font-size: 12px;
  text-align: center;
  line-height: 1;
  .active {
    color: #FFBE23;
  }
  i {
    margin-left: 0 !important
  }
}
</style>
